module.exports = __webpack_public_path__ + "img/invited@3x.cffacc45.png";